import { __deleteComment } from "@/store/helpers/discussion.helper.js";
export default {
  // SET_FOLDER_TABS(state, payload) {
  //   state.folderTabsList = payload;
  // },
  // SET_FOLDER_TABS_SKELETON(state, payload) {
  //   state.folderTabsSkeleton = payload;
  // },
  SET_FOLDER_TREE(state, payload) {
    state.foldersTree = payload;
  },
  ADD_FOLDER_TO_TREE(state, folderList){
    folderList.forEach(folder=>{
      const doesFolderExists = state.foldersTree.find(existingFolder => existingFolder?.id === folder?.id)
      if (!doesFolderExists){
        state.foldersTree.push(folder)
      }
    })
  
  },
  SET_FOLDER_TREE_SKELETON(state, payload) {
    state.folderTreeSkeleton = payload;
  },
  SET_PARENT_FOLDER_DETAILS(state, payload) {
    state.parentFolderDetails = payload;
  },
  SET_CHILD_FOLDER_DETAILS(state, payload) {
    state.childFolderDetails = payload;
  },
  SET_NESTED_CHILD_FOLDER_DETAILS(state, payload) {
    state.nestedChildFolderDetails = payload;
  },
  SET_TAB_NAME(state, payload) {
    state.tabName = payload;
  },
  SET_FOLDER_ARTICLE_CONTENT(state, payload) {
    state.folderArticleContent = payload;
  },
  SET_FOLDER_SUGGESTED_ARTICLE_CONTENT(state, payload) {
    state.folderSuggestedArticleContent = payload;
  },
  SET_FOLDER_MEDIA_CONTENT(state, payload) {
    state.folderMediaContent = payload;
  },
  SET_FOLDER_PODCASTS_CONTENT(state, payload) {
    state.folderPodcastContent = payload;
  },
  SET_FOLDER_BOOKS_CONTENT(state, payload) {
    state.folderBookContent = payload;
  },
  SET_FOLDER_ARTICLE_SKELETON(state, payload) {
    state.folderArticleSkeleton = payload;
  },
  SET_FOLDER_MEDIA_SKELETON(state, payload) {
    state.folderMediaSkeleton = payload;
  },
  SET_FOLDER_PODCASTS_SKELETON(state, payload) {
    state.folderPodcastSkeleton = payload;
  },
  SET_ARCHIVED_FOLDER(state, payload) {
    state.archivedFolder = payload;
  },

  // This is institute users users
  SET_INSTITUTE_USERS(state, payload) {
    const admins = payload.admins;
    const faculty = payload.faculty;
    const students = payload.students;

    let allUsers = admins.concat(faculty).concat(students);

    const userList = allUsers.map((user) => {
      return {
        label: user.full_name,
        value: user.id,
        key: user.email,
        icon: user.profile_picture,
      };
    });

    state.instituteUsers = payload.students;
  },

  // This is folders permissions users
  SET_USERS(state, userList) {
    state.usersWithFolderAccess = userList;
  },
  SET_FOLDER_COMMENTS(state, {folderCommentsArray, action='unshift'}={}) {
    folderCommentsArray.forEach((folderComment)=>{
      if (!state.folderCommentsIdArray.includes(folderComment?.id)){
        if (action === 'push'){
          state.folderCommentsIdArray.push(folderComment?.id)
        }else{
          state.folderCommentsIdArray.unshift(folderComment?.id)
        }
        state.folderComments.set(folderComment.id, folderComment)
      }
    })
  },
  ADD_NEW_FOLDER_COMMENT(state, folderComment){
    if (state.folderComments.has(folderComment?.parent)){
      const parentComment = state.folderComments.get(folderComment?.parent)
      const commentIndex = parentComment.child.findIndex(child=>child?.id === folderComment?.id)
      if (commentIndex < 0){
        parentComment.child.push(folderComment)
        state.folderComments.set(parentComment?.id, parentComment)
      }
    }
    else{
      if (!state.folderCommentsIdArray.includes(folderComment?.id)){
        state.folderCommentsIdArray.push(folderComment?.id)
        state.folderComments.set(folderComment.id, folderComment)
      }
    }
  },
  SET_FOLDER_ACTIVITY(state, payload) {
    state.folderActivity = [...state.folderActivity, ...payload.results];
  },
  SET_FOLDER_ACTIVITY_SKELETON(state, payload) {
    state.folderActivitySkeleton = payload;
  },
  SET_FOLDER_SUGGESTED_ARTICLE_SKELETON(state, payload) {
    state.folderSuggestedArticleSkeleton = payload;
  },
  SET_REQUESTED_FOLDER: (state, id) => {
    state.requestedFolderId = id;
    if (id) state.folderRequested = true;
    else state.folderRequested = false;
  },
  ADD_USERS(state, paylaod) {
    state.usersWithFolderAccess = paylaod;
  },
  SET_ARCHIVED_TAB(state, paylaod) {
    state.archive = paylaod
  },
  SET_FOLDER_TABS(state, folderTabs){
    state.folderTabs = folderTabs
  },
  TOGGLE_ARCHIVE(state) {
    state.showArchive = !state.showArchive;
  },
  SET_ARCHIVE(state, value) {
    state.showArchive = value;
  },
  SET_ACTIVE_FOLDER_TAB(state, activeFolderTab){
    state.activeFolderTab = activeFolderTab
  },
  SET_ACTIVE_FOLDER: (state, folder)=>{ state.activeFolder = folder },
  UPDATE_FOLDER_COMMENT: (state, comment)=>{
    if (state.folderComments.has(comment?.parent)){
      const parentComment = state.folderComments.get(comment?.parent)
      const commentIndex = parentComment.child.findIndex(child=>child?.id === comment?.id)
      if (commentIndex > -1){
        parentComment.child[commentIndex] = comment
        state.folderComments.set(comment?.parent, parentComment)
      }
    }
    else{
      if (state.folderComments.has(comment?.id)){
        state.folderComments.set(comment?.id, comment)
      }
    }
  },
  DELETE_FOLDER_COMMENT: (state, comment) => { 
    if (state.folderComments.has(comment?.parent)){
      const parentComment = state.folderComments.get(comment?.parent)
      const commentIndex = parentComment.child.findIndex(child=>child?.id === comment?.id)
      if (commentIndex > -1){
        parentComment.child.splice(commentIndex, 1)
        state.folderComments.set(comment?.parent, parentComment)
      }
    }else{
      if (state.folderComments.has(comment?.id)){
        const commentIndex = state.folderCommentsIdArray.findIndex(parentComment => parentComment === comment?.id)
        if (commentIndex > -1){
          state.folderCommentsIdArray.splice(commentIndex, 1)
          state.folderComments.delete(comment?.id)
        }
      }
    }
  },
  EMPTY_FOLDER_COMMENTS(state){
    state.folderComments = new Map()
    state.folderCommentsIdArray = []
  },
  SET_FOLDER_UNINVITED_USERS(state, payload){
    state.folderUninvitedUsers = payload
  },
  SET_CONTACT_INVITATION_FOLDER_ID(state, payload){
    state.contactInvitationFolderId = payload 
  },
  INC_OR_DEC_FOLDER_ARTICLE_CONTENT_PAGE(state, {action='inc'}={}){
    if (action === 'inc' && !state.hasReachedFolderArticleContentLimit)
      state.folderArticleContentPage += 1
    else if (action === 'dec' && state.folderArticleContentPage > 0){
      state.folderArticleContentPage -= 1
    }
  },
  SET_FOLDER_ARTICLE_CONTENT_LIMIT(state, limit){
    state.hasReachedFolderArticleContentLimit = limit
  },
  ADD_FOLDER_ARTICLE_CONTENT(state, contentArray){
    contentArray.forEach(newContent=>{
      const alreadyExists = state.folderArticleContent.find(existingContent=>existingContent?.id === newContent?.id)
      if (!alreadyExists){
        state.folderArticleContent.push(newContent)
      }
    })
  },
  RESET_FOLDER_ARTICLE_CONTENT_PAGE(state){
    state.hasReachedFolderArticleContentLimit = false
    state.folderArticleContentPage = 1
  },

  INC_OR_DEC_FOLDER_MEDIA_CONTENT_PAGE(state, {action='inc'}={}) {
    if (action === 'inc' && !state.hasReachedFolderMediaContentLimit)
      state.folderMediaContentPage += 1
    else if (action === 'dec' && state.folderMediaContentPage > 0) {
      state.folderMediaContentPage -= 1
    }
  },
  
  SET_FOLDER_MEDIA_CONTENT_LIMIT(state, limit) {
    state.hasReachedFolderMediaContentLimit = limit
  },
  
  ADD_FOLDER_MEDIA_CONTENT(state, contentArray) {
    contentArray.forEach(newContent => {
      const alreadyExists = state.folderMediaContent.find(existingContent => existingContent?.id === newContent?.id)
      if (!alreadyExists) {
        state.folderMediaContent.push(newContent)
      }
    })
  },
  
  RESET_FOLDER_MEDIA_CONTENT_PAGE(state) {
    state.hasReachedFolderMediaContentLimit = false
    state.folderMediaContentPage = 1
  },
  
  // Similar mutations for books and podcasts
  INC_OR_DEC_FOLDER_BOOK_CONTENT_PAGE(state, {action='inc'}={}) {
    if (action === 'inc' && !state.hasReachedFolderBookContentLimit)
      state.folderBookContentPage += 1
    else if (action === 'dec' && state.folderBookContentPage > 0) {
      state.folderBookContentPage -= 1
    }
  },
  
  SET_FOLDER_BOOK_CONTENT_LIMIT(state, limit) {
    state.hasReachedFolderBookContentLimit = limit
  },
  
  ADD_FOLDER_BOOK_CONTENT(state, contentArray) {
    contentArray.forEach(newContent => {
      const alreadyExists = state.folderBookContent.find(existingContent => existingContent?.id === newContent?.id)
      if (!alreadyExists) {
        state.folderBookContent.push(newContent)
      }
    })
  },
  
  RESET_FOLDER_BOOK_CONTENT_PAGE(state) {
    state.hasReachedFolderBookContentLimit = false
    state.folderBookContentPage = 1
  },
  
  INC_OR_DEC_FOLDER_PODCAST_CONTENT_PAGE(state, {action='inc'}={}) {
    if (action === 'inc' && !state.hasReachedFolderPodcastContentLimit)
      state.folderPodcastContentPage += 1
    else if (action === 'dec' && state.folderPodcastContentPage > 0) {
      state.folderPodcastContentPage -= 1
    }
  },
  
  SET_FOLDER_PODCAST_CONTENT_LIMIT(state, limit) {
    state.hasReachedFolderPodcastContentLimit = limit
  },
  
  ADD_FOLDER_PODCAST_CONTENT(state, contentArray) {
    contentArray.forEach(newContent => {
      const alreadyExists = state.folderPodcastContent.find(existingContent => existingContent?.id === newContent?.id)
      if (!alreadyExists) {
        state.folderPodcastContent.push(newContent)
      }
    })
  },
  
  RESET_FOLDER_PODCAST_CONTENT_PAGE(state) {
    state.hasReachedFolderPodcastContentLimit = false
    state.folderPodcastContentPage = 1
  },

  SET_FOLDER_SUGGESTED_ARTICLE_LIMIT(state, limit) {
    state.hasReachedFolderSuggestedArticleLimit = limit;
  },
  
  ADD_FOLDER_SUGGESTED_ARTICLE_CONTENT(state, contentArray) {
    // Filter out duplicates before adding
    contentArray.forEach(newContent => {
      const exists = state.folderSuggestedArticleContent.some(
        item => item.id === newContent.id
      );
      if (!exists) {
        state.folderSuggestedArticleContent.push(newContent);
      }
    });
  },

  RESET_FOLDER_SUGGESTED_ARTICLE_PAGE(state){
    state.hasReachedFolderSuggestedArticleLimit = false
    state.folderSuggestedArticlePage = 1
  },

  INC_OR_DEC_FOLDER_SUGGESTED_ARTICLE_PAGE(state, {action='inc'}={}){
    if (action === 'inc' && !state.hasReachedFolderSuggestedArticleLimit)
      state.folderSuggestedArticlePage += 1
    else if (action === 'dec' && state.folderSuggestedArticlePage > 0) {
      state.folderSuggestedArticlePage -= 1
    }
  },

  INC_OR_DEC_FOLDER_DISCUSSION_PAGE(state, {action='inc'}={}){
    if (action === 'inc' && !state.hasReachedFolderDiscussionLimit){
      state.folderDiscussionCurrentPage += 1
    }
    else if (action === 'dec' && state.folderDiscussionCurrentPage > 0) {
      state.folderDiscussionCurrentPage -= 1
    } 
  },

  SET_FOLDER_DISCUSSION_LIMIT(state, limit){
    state.hasReachedFolderDiscussionLimit = limit
  },

  RESET_FOLDER_DISCUSSION_PAGE(state){
    state.hasReachedFolderDiscussionLimit = false
    state.folderDiscussionCurrentPage = 1
  },

  SET_FOLDER_LIST_LIMIT(state, limit){
    state.hasReachedFolderListLimit = limit
  },

  RESET_FOLDER_LIST_CURRENT_PAGE(state){
    state.hasReachedFolderListLimit = false
    state.folderListCurrentPage = 1
  },

  INC_OR_DEC_FOLDER_LIST_CURRENT_PAGE(state, {action='inc'}={}){
    if (action === 'inc' && !state.hasReachedFolderListLimit)
      state.folderListCurrentPage += 1
    else if (action === 'dec' && state.folderListCurrentPage > 0) {
      state.folderListCurrentPage -= 1
    }
  },


}